export const AtlassianDataLakeMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.8 40.6001C31.48 40.6001 29.22 39.5501 27.43 37.6401C26.02 36.1301 24.9 35.9301 24 35.9301C23.1 35.9301 21.98 36.1301 20.57 37.6401C18.73 39.6001 16.38 40.6701 14.03 40.6001C11.78 40.5501 9.65001 39.4801 8.04001 37.6001C7.09001 36.4901 6.43001 36.3701 6.01001 36.3701H4.51001V32.7701H6.01001C7.76001 32.7701 9.36001 33.6101 10.78 35.2601C11.73 36.3701 12.88 36.9701 14.12 37.0001C14.15 37.0001 14.18 37.0001 14.21 37.0001C15.53 37.0001 16.85 36.3601 17.96 35.1801C19.75 33.2601 21.74 32.3301 24.02 32.3301C26.3 32.3301 28.29 33.2601 30.08 35.1801C31.21 36.3801 32.5 37.0601 33.92 37.0001C35.15 36.9701 36.3 36.3701 37.25 35.2601C38.67 33.6101 40.27 32.7701 42.02 32.7701H43.52V36.3701H42.02C41.6 36.3701 40.93 36.5001 39.99 37.6001C38.38 39.4801 36.25 40.5501 34 40.6001C33.94 40.6001 33.88 40.6001 33.83 40.6001H33.8Z"
      fill="#4382F7"
    />
    <path
      d="M34.64 31.87H32.84V13.29H36.44V27.05C36.44 27.05 36.53 26.96 36.58 26.92C37.88 25.71 39.5 24.2 42 24.2H43.5V27.8H42C40.99 27.8 40.2 28.46 39.03 29.55C37.87 30.63 36.55 31.86 34.64 31.86V31.87Z"
      fill="url(#paint0_linear_2189_2590)"
    />
    <path
      d="M13.36 31.87H15.16V13.29H11.56V27.05C11.51 27.01 11.47 26.96 11.42 26.92C10.12 25.71 8.5 24.2 6 24.2H4.5V27.8H6C7.01 27.8 7.8 28.46 8.97 29.55C10.13 30.63 11.45 31.86 13.36 31.86V31.87Z"
      fill="url(#paint1_linear_2189_2590)"
    />
    <path
      d="M24.0001 19.1799C18.0101 19.1799 11.5601 17.3399 11.5601 13.2899C11.5601 9.2399 18.0101 7.3999 24.0001 7.3999C29.9901 7.3999 36.4401 9.2399 36.4401 13.2899C36.4401 17.3399 29.9901 19.1799 24.0001 19.1799ZM24.0001 10.9999C18.4201 10.9999 15.3701 12.6899 15.1601 13.3299C15.3701 13.8899 18.4201 15.5799 24.0001 15.5799C29.5801 15.5799 32.6301 13.8899 32.8401 13.2499C32.6301 12.6899 29.5801 10.9999 24.0001 10.9999Z"
      fill="#4382F7"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2189_2590"
        x1="38.76"
        y1="18.08"
        x2="35.39"
        y2="32.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A82F6" />
        <stop offset="1" stopColor="#2253CA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2189_2590"
        x1="9.25"
        y1="18.08"
        x2="12.61"
        y2="32.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A82F6" />
        <stop offset="1" stopColor="#2253CA" />
      </linearGradient>
    </defs>
  </svg>
);
